export const shouldShowFallbackWaitingBubble = ({
  isOrbAnchor = false,
  loadingResponse = false,
  responseTextHasStarted = false,
  hasEnteredLiveTextPhase = false,
  showLoadingOrbit = false,
} = {}) => (
  Boolean(isOrbAnchor) &&
  Boolean(loadingResponse) &&
  !responseTextHasStarted &&
  !hasEnteredLiveTextPhase &&
  !showLoadingOrbit
);
